export const HOME_POST_BANNER_HEADER_CLICK_EVENT = 'home-post-banner-header-click';

export const notifyHomePostBannerHeaderClick = (): void => {
    if (typeof window === 'undefined') return;

    window.dispatchEvent(new Event(HOME_POST_BANNER_HEADER_CLICK_EVENT));
};
